import React from "react";
import { DeleteOutlineOutlined, EditOutlined } from "@material-ui/icons";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import styles from "./ActionsFieldStyles.module.css";
import classnames from "classnames";

export const ActionsField = ({
  hideDeleteIcon = false,
  onDelete = () => {},
  onEdit = () => {},
}) => {
  const isDesktop = useDesktopMediaQuery();
  return (
    <div className={styles.wrapper}>
      <div className={styles.iconWrapper} onClick={onEdit}>
        <EditOutlined className={classnames(styles.icon, styles.editIcon)} />
        {!isDesktop && <span>Edit</span>}
      </div>
      {!hideDeleteIcon && (
        <div
          className={classnames(styles.iconWrapper, "text-danger")}
          onClick={onDelete}
        >
          <DeleteOutlineOutlined className={classnames(styles.icon)} />
          {!isDesktop && <span>Delete</span>}
        </div>
      )}
    </div>
  );
};
